<img
  ngSrc="assets/img/logo_rain_mesh.svg"
  alt="Logo RainMesh"
  height="32"
  width="96"
  priority
/>
